import { colors } from "shared/theme/color";
// The Spott cube mark (bare cube, navy strokes, amber facet). Same geometry as
// the marketing site's Logo.astro and the navy-tile favicons in public/.
import LogoImg from "../../assets/spott-logo.svg";
import { textPx } from "shared/constants/zoom";

interface SpottLogoProps {
  style?: React.CSSProperties;
  textSize?: 1 | 2 | 3 | 4 | 5;
  /** Sidebar collapsed: the cube alone. Expanded: the cube + wordmark lockup. */
  collapsed?: boolean;
}

/**
 * The brand lockup, in the marketing site header's proportions (26px cube,
 * 19px word) with the gap halved to 6px, which reads tighter at app sizes:
 * Inter Tight 600 at -0.045em, ink, lowercase.
 *
 * The word is always in the DOM and fades with the Sider's own 0.2s width
 * transition. Mounting it only when expanded made the cube flicker: the word
 * appeared at full width inside a still-narrow, overflow-clipped row and the
 * cube (a shrinkable flex item) gave up its width for a frame. The cube is
 * `flexShrink: 0`, so it holds 30px whatever the row is doing.
 */
const SpottLogo: React.FC<SpottLogoProps> = ({ style, textSize = 2, collapsed = false }) => {
  return (
    <div style={{ ...style, display: "flex", alignItems: "center", gap: 6, overflow: "hidden" }}>
      <img src={LogoImg} alt="" aria-hidden="true" style={{ width: 30, height: 30, display: "block", flexShrink: 0 }} />
      <span
        aria-hidden={collapsed}
        style={{
          fontFamily: "var(--font-display)",
          fontWeight: 600,
          fontSize: textPx(22),
          letterSpacing: "-0.045em",
          lineHeight: 1,
          color: colors.ink,
          whiteSpace: "nowrap",
          opacity: collapsed ? 0 : 1,
          transition: "opacity 0.2s",
        }}
      >
        spott
      </span>
    </div>
  );
};

export default SpottLogo;
